import { Skeleton } from '@/components/ui/skeleton';
import React from 'react';
import { View } from 'react-native';

/**
 * Loading placeholder for {@link CuisineChip}. Mirrors its `items-center mr-4
 * w-20` column, 56px rounded tile, and label line so the Categories rail holds
 * its height while cuisines load.
 */
const CuisineChipSkeleton = React.memo(() => (
  <View className="items-center mr-4 w-20">
    <Skeleton width={56} height={56} radius={12} style={{ marginBottom: 6 }} />
    <Skeleton width={48} height={10} radius={4} />
  </View>
));

CuisineChipSkeleton.displayName = 'CuisineChipSkeleton';

export default CuisineChipSkeleton;
